import { useEffect, useState } from "react";
import { useQuery, useLazyQuery } from "react-apollo";
import { SINGLE_SYSTEM_CODE_QUERY } from "../graphql/SystemCodes/SystemCodes.graphql";
import { SINGLE_ITEM_CATEGORY_QUERY } from "../graphql/ItemCategories/ItemCategories.graphql";
import { ALL_INSPECTION_MASTER_QUERY } from "../graphql/InspectionMaster/InspectionMaster.graphql";

function useOdometerRequired(
  WOTypRecIdRef,
  ItemCatgRecIdRef,
  VehicleTypeRecIdRef
) {
  const [odometerRequired, setOdometerRequired] = useState(false);
  const [getWorkOrderType, { data: WorkOrderTypeData }] = useLazyQuery(
    SINGLE_SYSTEM_CODE_QUERY
  );
  const [getItemCategory, { data: ItemCategoryData }] = useLazyQuery(
    SINGLE_ITEM_CATEGORY_QUERY
  );

  const { data: InspectionMasterData } = useQuery(ALL_INSPECTION_MASTER_QUERY);

  useEffect(() => {
    if (WOTypRecIdRef) {
      getWorkOrderType({
        variables: { where: { RecId: parseInt(WOTypRecIdRef, 10) } }
      });
    }
  }, [WOTypRecIdRef, getWorkOrderType]);

  useEffect(() => {
    if (ItemCatgRecIdRef) {
      getItemCategory({
        variables: { where: { RecId: parseInt(ItemCatgRecIdRef, 10) } }
      });
    }
  }, [ItemCatgRecIdRef, getItemCategory]);

  useEffect(() => {
    const isInspectionService =
      WorkOrderTypeData?.SystemCode?.CodeDescription === "Inspection Service";
    const inspectionCodeRecIdRef =
      ItemCategoryData?.ItemCategory?.InspectionCdRecIdRef;

    const inspectionMasters = InspectionMasterData?.InspectionMasters;

    if (isInspectionService && inspectionCodeRecIdRef && inspectionMasters) {
      const match = inspectionMasters.find(
        master =>
          master.InspecCdRecIdRef === inspectionCodeRecIdRef &&
          master.VehicleTypeRecIdRef === VehicleTypeRecIdRef
      );
      if (match) {
        setOdometerRequired(match.OdometerReq);
      }
    } else {
      setOdometerRequired(false);
    }
  }, [
    InspectionMasterData,
    ItemCategoryData,
    VehicleTypeRecIdRef,
    WorkOrderTypeData
  ]);

  return odometerRequired;
}

export default useOdometerRequired;
